import { QuestionCircleOutlined } from '@ant-design/icons'
import Popover from '../../../atoms/Popover'
import { ReactNode } from 'react'

type HelpPopoverProps = {
  title: string | undefined
  content: ReactNode | undefined
  className?: string
}

const HelpPopover = (props: HelpPopoverProps) => {
  const { title, content, className } = props

  return (
    <Popover title={title} content={content}>
      <QuestionCircleOutlined className={className} />
    </Popover>
  )
}

export default HelpPopover
